<template>
  <div class="qualify">
    <aside class="notice" aria-label="Aviso">
      <span class="notice-tag">Um instante</span>
      <h1 class="notice-text">
        Antes de te conectar com um gerente no WhatsApp,
        <em>conta pra gente o que você precisa</em> —
        assim a gente te direciona melhor.
      </h1>
    </aside>

    <ul
      class="options"
      role="listbox"
      aria-label="Funcionalidades"
    >
      <li
        v-for="service in services"
        :key="service.id"
      >
        <button
          type="button"
          class="option"
          :class="{ selected: selected === service.id }"
          role="option"
          :aria-selected="selected === service.id"
          @click="selected = service.id"
        >
          <span
            class="option-check"
            aria-hidden="true"
          />
          <span class="option-label">{{ service.label }}</span>
        </button>
      </li>
    </ul>

    <div class="page-actions">
      <button
        type="button"
        class="btn btn-primary"
        :disabled="!selected"
        @click="continueFlow"
      >
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
import { SERVICES } from '@/constants/services'

export default {
  name: 'HomeView',
  data() {
    return {
      services: SERVICES,
      selected: null
    }
  },
  methods: {
    continueFlow() {
      if (!this.selected) return

      if (this.selected === 'emprestimo') {
        this.$router.push({ name: 'no-loan' })
        return
      }

      this.$router.push({
        name: 'form',
        query: { servico: this.selected }
      })
    }
  }
}
</script>

<style scoped>
.qualify {
  display: flex;
  flex-direction: column;
}

.options {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: var(--tap);
  padding: 0.75rem 0.875rem;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg);
  color: var(--text);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.option:active {
  background: var(--bg-soft);
}

.option.selected {
  border-color: var(--brand-blue);
  background: rgba(6, 65, 252, 0.05);
}

.option-check {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  border: 1.5px solid var(--border-hover);
  border-radius: 50%;
  position: relative;
}

.option.selected .option-check {
  border-color: var(--brand-blue);
  background: var(--brand-blue);
}

.option.selected .option-check::after {
  content: '';
  position: absolute;
  top: 0.2rem;
  left: 0.35rem;
  width: 0.3rem;
  height: 0.55rem;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.option-label {
  flex: 1;
  font-size: var(--font-base);
  line-height: 1.35;
}

@media (hover: hover) {
  .option:hover {
    border-color: var(--border-hover);
    background: var(--bg-soft);
  }
}
</style>
